export default {
    setUserProfileData(state, data) {
      state.user = data.user
    }
}